import { render, staticRenderFns } from "./OpenLiveAccount.vue?vue&type=template&id=0fcf17cc"
import script from "./OpenLiveAccount.vue?vue&type=script&lang=js"
export * from "./OpenLiveAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports